export default function DonutCard({ name, iname, qty, setQty }) {
  const handleIncrement = () => setQty(qty + 1);
  const handleDecrement = () => setQty(Math.max(0, qty - 1));

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-4 flex flex-col items-center text-center transition hover:shadow-xl h-full">
      <img
        src={`/images/${iname}-donut.jpg`}
        alt={`${name} donut`}
        className="w-24 h-24 object-cover rounded-full mb-2"
      />
      <h3 className="text-lg font-semibold text-pink-600 dark:text-pink-300">{name}</h3>

      {/* Spacer pushes the controls to the bottom */}
      <div className="flex-grow" />

      <div className="flex items-center gap-2 mt-4">
        <button
          onClick={handleDecrement}
          className="px-3 py-1 text-lg bg-pink-100 dark:bg-gray-700 text-pink-600 rounded-full font-bold hover:bg-pink-200"
        >
          −
        </button>
        <span className="w-6 text-center text-md">{qty}</span>
        <button
          onClick={handleIncrement}
          className="px-3 py-1 text-lg bg-pink-100 dark:bg-gray-700 text-pink-600 rounded-full font-bold hover:bg-pink-200"
        >
          +
        </button>
      </div>
    </div>
  );
}
